module.exports = __webpack_public_path__ + "img/bbafa1c.jpg";